import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import MobileStickyCTA from "./MobileStickyCTA";
import ScrollToHash from "./ScrollToHash";


export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-offwhite text-charcoal">
            <ScrollToHash />
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <MobileStickyCTA />
            <CookieBanner />
        </div>
    );
}


export function usePageMeta({ title, description, robots }) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            let m = document.querySelector('meta[name="description"]');
            if (!m) {
                m = document.createElement("meta");
                m.setAttribute("name", "description");
                document.head.appendChild(m);
            }
            m.setAttribute("content", description);
        }
        if (robots) {
            let r = document.querySelector('meta[name="robots"]');
            if (!r) {
                r = document.createElement("meta");
                r.setAttribute("name", "robots");
                document.head.appendChild(r);
            }
            r.setAttribute("content", robots);
        }
    }, [title, description, robots]);
}
